export const TRANSFER_USER_ID = "userId";
export const USERS = "users";
export const OWNER_NAME = "name";
export const ROLE = "role";
export const CURRENT_SHARE = "currentShare";
export const NEW_SHARE = "newShare";
export const IS_NEW_USER = "isNewUser";
export const USER_ID = "userId"